// src/components/ui/toast.js — tiny imperative toast, the app-wide replacement
// for alert(). Imperative DOM (no context/provider) so any component or plain
// function can call it. Announced politely to screen readers; honours
// prefers-reduced-motion via the CSS in index.css (.pp-toast).

const TONES = {
  info: 'border-slate-600 text-slate-100',
  success: 'border-emerald-500/60 text-emerald-100',
  warn: 'border-amber-500/60 text-amber-100',
};

let container = null;

const getContainer = () => {
  if (container && document.body.contains(container)) return container;
  container = document.createElement('div');
  container.className = 'fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col items-center gap-2 px-4 w-full max-w-md pointer-events-none';
  container.setAttribute('role', 'status');
  container.setAttribute('aria-live', 'polite');
  document.body.appendChild(container);
  return container;
};

export function showToast(message, { tone = 'info', duration = 3600 } = {}) {
  const host = getContainer();
  const el = document.createElement('div');
  el.className = `pp-toast pointer-events-auto rounded-xl border bg-slate-900/95 backdrop-blur-sm shadow-lg px-4 py-3 text-sm leading-snug text-center ${TONES[tone] || TONES.info}`;
  el.textContent = message;
  host.appendChild(el);
  const leave = () => {
    el.classList.add('pp-toast-leaving');
    setTimeout(() => el.remove(), 250);
  };
  const timer = setTimeout(leave, duration);
  el.addEventListener('click', () => { clearTimeout(timer); leave(); });
  return el;
}
